import React, { Component } from 'react'
import './css/index.css'
import Button from "../../components/Button"
import nigeria from "../../assets/images/Nigeria.svg"

class GettingStarted extends Component {
    render() {
        return (
            <div className="gettingStarted">
                <div className="startedText">
                    <h1 className="main-color">GETTING STARTED</h1>
                    <p>Fill in necessary details as requested in the form.</p>
                </div>
                <div className="accForm">
                    <div className="formContent">
                        <form>
                            <div className="formFlex">
                                <div className="form-group">
                                    <label>First Name</label>
                                    <input placeholder="Moyin" className="formInput" />
                                </div>
                                <div className="form-group">
                                    <label>Last Name</label>
                                    <input placeholder="Emmanuel" className="formInput"/>
                                </div>
                            </div>
                            <div className="formFlex">
                                <div className="form-group">
                                    <label>Enter Email Address</label>
                                    <input placeholder="moyinemmanuel@gmail.com" className="formInput"/>
                                </div>
                                <div className="form-group">
                                    <label>Enter Phone Number</label>
                                    <div className="form-country">
                                        {/* <div>
                                            <img src={nigeria} alt="nigeria" />
                                        </div> */}
                                        <input placeholder="hahahahahah" className="formInput"/>
                                    </div>
                                </div>
                            </div>
                            <div className="formFlex">
                                <div className="form-group">
                                    <label>Amount to be traded</label>
                                    <input placeholder="hahahahahah" className="formInput"/>
                                </div>
                                <div className="form-group">
                                    <label>Duration of Management</label> <br/>
                                    <select className="formInput"> 
                                        <option>3 Month</option>
                                        <option>6 Month</option>
                                        <option>9 Month</option>
                                    </select>
                                </div>
                                
                            </div>
                            <div className="formFlex topAcc">
                                <div className="ac"><input type="checkbox" />I agree to <span>terms and condition</span></div>
                            </div>
                            <div className="formFlex topAcc">
                                <Button className="account-submit">Submit</Button>
                            </div>
                        </form>  
                    </div>
                </div>
            </div>
        )
    }
}

export default GettingStarted;